module.exports = __webpack_public_path__ + "static/img/1-2.a3d02e6e.jpg";